module.exports = __webpack_public_path__ + "img/pay.2ea96a2c.png";